import { CurrentAgentStatus, customSWRConfig } from '../../model/types';
import useAgentStatus from './useAgentStatus';

export default function useAgentChatStatus(config: customSWRConfig = {}): CurrentAgentStatus['status']['chat'] {
    const { data } = useAgentStatus(config);

    return data?.status?.chat;
}
